
import useDataFetcher from '../../../knisot/hooks/useFetchData'
import { Warehouse } from '../../../../../../modules/API/Warehouse/warehouse'
import { IProductLocation } from '../../../../../../modules/API/Warehouse/models/responses'

type Props = {
  productID: number
  varietyID: number
  sizeID: string
  packID: number
}

const useProductLocationById = ({
  productID,
  varietyID,
  sizeID,
  packID,
}: Props) => {
  const {
    data,
    isLoading,
    error,
  } = useDataFetcher<IProductLocation>(
    Warehouse.getProductLocation, `ProductID=${productID}&VarietyID=${varietyID}&SizeID=${sizeID}`
  )
  
  return (
    {
      data: data,
      isLoading: isLoading,
      error: error,
    }
    )
}

export default useProductLocationById